import { ME } from '@graphql/me'
import { Login } from '@graphql/__generated__/Login'
import { Me, Me_me } from '@graphql/__generated__/Me'
import React, { FC, useContext, useEffect, useState } from 'react'
import { useQuery } from 'urql'
import { useResetClient } from './UrqlClientProvider'
type State = {
  me: null | Me_me
}

interface Methods {
  logout: () => void
  login: (data: Login) => void
}

const AuthContext = React.createContext<State & Methods>({
  me: null,
  logout: () => null,
  login: () => null
})

type Props = {}

const AuthContextProvider: FC<Props> = ({ children }) => {
  const { resetClient } = useResetClient()
  const [state, setState] = useState<Me_me | null>()
  const [{ data }, reexecuteQuery] = useQuery<Me>({ query: ME, requestPolicy: 'cache-and-network' })
  const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
    resetClient()
  }

  const login = data => {
    window.localStorage.setItem('token', data.login.token)
    window.localStorage.setItem('refresh_token', data.login.refreshToken)
    reexecuteQuery()
  }

  useEffect(() => {
    if (data) {
      setState(data.me)
    }
  }, [data])

  return (
    <AuthContext.Provider value={{ me: state, logout, login }}>{children}</AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)

export default AuthContextProvider
